import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MaterialTable from "material-table";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";

import { TimePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Box, createTheme, DialogContentText, FormControl, Tab, TextField } from "@material-ui/core";

import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";
import isEqual from "date-fns/isEqual";

import { timeConvertUtility } from "../../utilities/utility";

// import { initializeApp, getApps, getApp } from "firebase/app";
import { checkUserAccess, db, getCheckSession, getUserName, logout } from "../../apis/auth";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
  increment,
} from "firebase/firestore";
import "../../styles/settings.scss";
import { getDimSchedule, updateDimSchedule } from "../../query/dim-schedule.query";

import { DimSchedule } from "../Settings/dim-schedule.screen";
import { createDimScheduleHistory } from "../../query/dim-schedule-history.query";
import { NotificationManager } from "react-notifications";
import { SLCFirmwarePhase1 } from "./slc_firmware_phase1";
import { SLCFirmwarePhase3 } from "./slc_firmware_phase3";
import { ILMFirmware } from "./ilm_firmware";
import { createConfig, getConfigHistoryAPICall, getConfigInfoAPICall, getDataFromAPICall, getHistoryFromAPICall } from "../../query/config.query";

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const Config = () => {
  const history = useHistory();
  const classes = useStyles();
  const [scheduleHistoryData, setConfigHistoryData] = useState([]);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [historyDialog, setHistoryDialog] = useState(false);
  const [configDocId, setConfigDocId] = useState(null);
  const [selectedTab, setSelectedTab] = React.useState('a');
  const [configDialog, setConfigDialog] = useState({ max_volt: 0, min_volt: 0, min_power_usage: 0, max_power_usage: 0, data_freq: 0, ver: 0 });
  const [configData, setConfigData] = useState([]);
  const [tabs, setTabs] = useState([]);
  const onChangeTabView = (event, newValue) => {
    setSelectedTab(newValue);
  }

  useEffect(async () => {
    console.log("========== LiveMeterFeed : OnInit() ==========");
    var sessionStatus = await getCheckSession();
    if (sessionStatus === false) {
      history.push("/");
      return;
    }
    await getConfigInfo();
    var viewConfig = checkUserAccess("view_config");
    var viewSLC1 = checkUserAccess("view_config_slc1");
    var viewSLC3 = checkUserAccess("view_config_slc3");
    var viewILM = checkUserAccess("view_config_ilm");

    var tabItems = [];
    if (viewConfig === true) {
      setSelectedTab("CONFIG");
    } else if (viewSLC1 === true) {
      setSelectedTab("SLC Phase 1");
    } else if (viewSLC3 === true) {
      setSelectedTab("SLC Phase 3");
    } else if (viewILM === true) {
      setSelectedTab("ILM");
    }

    if (viewConfig === true) {
      tabItems.push("CONFIG");
    }
    if (viewSLC1 === true) {
      tabItems.push("SLC Phase 1");
    }
    if (viewSLC3 === true) {
      tabItems.push("SLC Phase 3");
    }
    if (viewILM === true) {
      tabItems.push("ILM");
    }
    setTabs(tabItems);
  }, []);

  const handleClose = () => {
    setIsOpenDialog(false);
    setConfigDialog(configData);
    setFormErrors({})
  };

  const handleEdit = () => {
    setIsOpenDialog(true);
  };

  const compareObjectsExceptVer = (obj1, obj2) => {
    const keys1 = Object.keys(obj1).filter(key => key !== 'ver');
    const keys2 = Object.keys(obj2).filter(key => key !== 'ver');
    if (keys1.length !== keys2.length) return false;
    return keys1.every(key => JSON.stringify(obj1[key]) === JSON.stringify(obj2[key]));
  };

  const getSaveDisabledStatus = () => {
    return configDialog && configData ? compareObjectsExceptVer(configDialog, configData) : false;
  };

  const handleSelectedDate = (data, field) => {
    const value = data?.target?.value || "";
    setFormErrors((prevErrors) => ({ ...prevErrors, [field]: undefined }));
    setConfigDialog((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const getScheduleHistoryColumnList = () => {
    return [
      {
        title: 'Max Voltage',
        render: ({ max_volt: max_volt = 0 }) => {
          if (max_volt != 0) {
            return max_volt;
          }
          return 0;
        },
      },
      {
        title: 'Min Voltage',
        render: ({ min_volt: min_volt = 0 }) => {
          if (min_volt != 0) {
            return min_volt;
          }
          return 0;
        },
      },
      {
        title: 'Lamp Off Threshold',
        render: ({ min_power_usage: min_power_usage = 0 }) => {
          if (min_power_usage != 0) {
            return min_power_usage;
          }
          return 0;
        },
      },
      {
        title: 'Theft Threshold',
        render: ({ max_power_usage: max_power_usage = 0 }) => {
          if (max_power_usage != 0) {
            return max_power_usage;
          }
          return 0;
        },
      },
      {
        title: 'Data frequency',
        render: ({ data_freq: data_freq = 0 }) => {
          if (data_freq != 0) {
            return data_freq;
          }
          return 0;
        },
      },
      {
        title: 'Version',
        render: ({ ver: ver = 0 }) => {
          if (ver != 0) {
            return ver;
          }
          return 0;
        },
      },
      {
        title: 'Date',
        render: ({ ch_dt: ch_dt = 0 }) => {
          if (ch_dt != 0) {
            return format(ch_dt.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return 0;
        },
      },
      {
        title: 'Modified By',
        render: ({ user: user = 0 }) => {
          if (user != 0) {
            return user;
          }
          return 0;
        },
      },
    ];
  };

  const getScheduledTime = () => {
    const { max_volt = 0, min_volt = 0, min_power_usage = 0, max_power_usage = 0, data_freq = 0, ver = 0 } = configData;
    return (
      <Grid xs={3} sm={3}>
        <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 'bold' }}>Max Voltage</span>
          <span>{max_volt}</span>
        </div>
        <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 'bold' }}>Min Voltage</span>
          <span>{min_volt}</span>
        </div>
        <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 'bold' }}>Lamp Off Threshold</span>
          <span>{min_power_usage}</span>
        </div>
        <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 'bold' }}>Theft Threshold</span>
          <span>{max_power_usage}</span>
        </div>
        <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 'bold' }}>Data Frequency</span>
          <span>{data_freq}</span>
        </div>
        <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 'bold' }}>Version</span>
          <span>{ver}</span>
        </div>
      </Grid>
    );
  };

  const getConfigInfo = async () => {
    await getDataFromAPICall('settings',"config")
      .then((result) => {
        const { docId, configInfo } = result;
        if (docId != null) {
          setConfigDocId(docId);
          setConfigDialog(configInfo);
          setConfigData(configInfo);
        }

      })
      .catch(() => {
        NotificationManager.error("Unable to fetch cofig data", "", 3000);
      });
  }

  const getConfigHistory = async () => {
    let collectionName = "cfg_upd_hist";
    await getHistoryFromAPICall(collectionName).then((historyList) => {
      setConfigHistoryData(historyList);
      setHistoryDialog(true)
    }).catch(() => {
      NotificationManager.error("Unable to fetch history data", "", 3000);
    });
  };
  var editSLC = checkUserAccess("edit_config")
  var viewConfig = checkUserAccess("view_config")
  var viewSLC1 = checkUserAccess("view_config_slc1")
  var viewSLC3 = checkUserAccess("view_config_slc3")
  var viewILM = checkUserAccess("view_config_ilm")

  var tabList = tabs;

  const [formErrors, setFormErrors] = useState({});

  const validateForm = () => {
    let errors = {};

    if (!configDialog.max_volt || isNaN(configDialog.max_volt) || configDialog.max_volt <= 0.1) {
      errors.max_volt = 'Valid Max Voltage is required';
    }
    if (!configDialog.min_volt || isNaN(configDialog.min_volt) || configDialog.min_volt <= 0) {
      errors.min_volt = 'Valid Min Voltage is required';
    }
    if (!configDialog.min_power_usage || isNaN(configDialog.min_power_usage)) {
      errors.min_power_usage = 'Valid Lamp Off Threshold is required';
    }
    if (!configDialog.max_power_usage || isNaN(configDialog.max_power_usage)) {
      errors.max_power_usage = 'Valid Theft Threshold is required';
    }
    if (!configDialog.data_freq || isNaN(configDialog.data_freq)) {
      errors.data_freq = 'Valid Data Frequency is required';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleFormSubmit = () => {
    if (validateForm()) {
      createConfig(configDocId, configDialog)
        .then(() => {
          NotificationManager.success("Successfully Save Config data", "", 3000);
          setIsOpenDialog(false);
          getConfigInfo();
        })
        .catch((e) => {
           NotificationManager.error("Unable to create config data", "", 3000);
        });
    }
  };

  return (
    <div className="settings">
      <Grid container className="main-header">
        <Grid className="font-bold">Config</Grid>
      </Grid>

      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={selectedTab} classes={{ root: classes.tab }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={onChangeTabView} aria-label="live meter feed" indicatorColor='primary'>
              {tabList.map((tab, index) => (
                <Tab value={tab} label={tab} />
              ))}
              {/* {<Tab label="CONFIG" value="a" />}
              {viewSLC1 && (<Tab label="SLC Phase 1" value="b" />)}
              {viewSLC3 && (<Tab label="SLC Phase 3" value="c" />)}
              {viewILM && (<Tab label="ILM" value="d" />)} */}
            </TabList>
          </Box>
          {viewConfig && (<TabPanel value="CONFIG" style={{ padding: '0px' }}>
            <Grid container>
              <Grid xs={12} sm={12}>
                <div className="settings-schedule-wrapper">
                  <h5 className="header">Config</h5>
                  <div style={{ padding: '10px' }} >{getScheduledTime()}</div>
                  <div className="edit-btn-wrapper">
                    <Button
                      variant="contained"
                      className="edit-btn"
                      onClick={() => {
                        getConfigHistory();
                      }}>
                      History
                    </Button>
                    {editSLC && <Button
                      variant="contained"
                      className="edit-btn"
                      onClick={() => {
                        handleEdit();
                      }}>
                      Edit
                    </Button>}
                  </div>
                </div>
              </Grid>
            </Grid>
          </TabPanel>)}
          {viewSLC1 && (<TabPanel value="SLC Phase 1" style={{ padding: '0px' }}>
            <SLCFirmwarePhase1 />
          </TabPanel>)}
          {viewSLC3 && (<TabPanel value="SLC Phase 3" style={{ padding: '0px' }}>
            <SLCFirmwarePhase3 />
          </TabPanel>)}
          {viewILM && (<TabPanel value="ILM" style={{ padding: '0px' }}>
            <ILMFirmware />
          </TabPanel>)}
        </TabContext>
      </Box>
      {/* Add & Edit Config */}
      <Dialog
        className="change-schedule-dialog"
        onClose={handleClose}
        aria-labelledby="editTime-dialog-title"
        open={isOpenDialog}
        fullWidth
        PaperProps={{
          component: 'form',
          onKeyDown: (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
            }
          },
          onSubmit: (event) => {
            event.preventDefault();
            handleFormSubmit()
          },
        }}
      >
        <DialogTitle id="editTime-dialog-title" onClose={handleClose}>
          Change Config
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              autoFocus
              margin="dense"
              id="max voltage"
              label="Max Voltage"
              error={!!formErrors.max_volt}
              helperText={formErrors.max_volt}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => handleSelectedDate(e, 'max_volt')}
              value={configDialog.max_volt}
            />
          </FormControl>

          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              margin="dense"
              id="min voltage"
              label="Min Voltage"
              error={!!formErrors.min_volt}
              helperText={formErrors.min_volt}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => handleSelectedDate(e, 'min_volt')}
              value={configDialog.min_volt}
            />
          </FormControl>

          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              margin="dense"
              id="lamp off threshold"
              label="Lamp Off Threshold"
              error={!!formErrors.min_power_usage}
              helperText={formErrors.min_power_usage}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => handleSelectedDate(e, 'min_power_usage')}
              value={configDialog.min_power_usage}
            />
          </FormControl>

          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              margin="dense"
              id="theft threshold"
              label="Theft Threshold"
              error={!!formErrors.max_power_usage}
              helperText={formErrors.max_power_usage}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => handleSelectedDate(e, 'max_power_usage')}
              value={configDialog.max_power_usage}
            />
          </FormControl>

          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              margin="dense"
              id="data frequency"
              label="Data Frequency"
              error={!!formErrors.data_freq}
              helperText={formErrors.data_freq}
              onWheel={(e) => e.target.blur()}
              onChange={(e) => handleSelectedDate(e, 'data_freq')}
              value={configDialog.data_freq}
            />
          </FormControl>

          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              margin="dense"
              id="Version"
              label="Version"
              value={configDialog.ver + 1 || 1}
              disabled
            />
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Button
            className="save-btn"
            type="submit"
            disabled={getSaveDisabledStatus()}  >
            Save
          </Button>
          <Button className="save-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* History Dialog */}
      <Dialog className="history-dialog" open={historyDialog} onClose={() => { setHistoryDialog(false) }} aria-labelledby="form-dialog-title" fullWidth maxWidth={'md'}>
        <DialogTitle id="form-dialog-title"> History </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {historyDialog?.desc}
          </DialogContentText>
          <MaterialTable
            style={{
              // margin: "20px 0",
              width: "100%",
            }}
            className={classes.table}
            title={<div className="title">Config Change History</div>}
            columns={getScheduleHistoryColumnList()}
            data={scheduleHistoryData}
            options={{
              exportButton: false,
              // grouping: true,
              search: false,
              selection: false,
              sorting: true,
              pageSize: 5,
              headerStyle: {
                backgroundColor: "#0071CE",
                color: "#FFF",
                fontSize: "0.9em",
                textAlign: "center",
              },
              actionsColumnIndex: -1,
              emptyRowsWhenPaging: false,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setHistoryDialog(false) }} color="primary">
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Config;
